import { render, staticRenderFns } from "./MetadadosExtensao.vue?vue&type=template&id=b2b13a88&lang=html&"
import script from "./MetadadosExtensao.vue?vue&type=script&lang=js&"
export * from "./MetadadosExtensao.vue?vue&type=script&lang=js&"
import style0 from "./MetadadosExtensao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/MetadadosExtensao.vue
// module id = 528
// module chunks = 28